<div (click)="stopPropagation($event)">
    <!-- Render different content based on the number of selected rows -->
    <ng-container *ngIf="selectedRows.length === 0">
        <!-- No rows selected -->
        <p class="selectedRows body-1">Select an item to see the details</p>
    </ng-container>

    <!-- Template for multiple rows selected -->
    <ng-container *ngIf="selectedRows.length > 1">
        <p class="selectedRows body-1">
            {{ selectedRows.length }} rows have been selected
        </p>
    </ng-container>

    <!-- Template for single selection -->
    <ng-container *ngIf="selectedRows.length === 1">
        <!--Info Panel tabs section start-->
        <div class="tabs-section" *ngIf="!rowData.is_readonly" >
            <sync-tabs [tabLinks]="infoTabs" tabsPosition="center" [onSelectionTab]="onTabChange">
            </sync-tabs>
        </div>
        <!--Info Panel tabs section ends-->

        <div *ngIf="isLoading" class="info-panel-loader">
            <sync-spinner></sync-spinner>
        </div>

        <ng-container *ngIf="!isLoading">
            <!--info for read only folder start -->
            <div class="read-only-container" *ngIf="rowData.is_readonly">
                <div class="info-read-only">
                    <div class="info-preview">
                        <span *ngIf="!rowData.thumbsrc" class="file-type-icon">
                            <sync-icon [name]="fileItemService.getFileTypeIcon(rowData)"></sync-icon>
                        </span>
                    </div>
                    <div class="read-only-content-container">
                        <div class="read-only-content">
                            <img src="assets/icons/Protected.svg">
                            <div class="read-only-message">
                                <div class="subtitle-1">You have view-only permission set by the folder owner.</div>
                                <div class="body-2 text-message">Contact the folder owner to request a permission change.</div>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
            <!--info for read only folder end -->

            <!-- Include your Info tab content start -->
            <div *ngIf="activeTab === 'Info' && !rowData.is_readonly" class="tab-content info-container">
                <span *ngIf="rowData.thumbsrc" class="thumbnail" [ngStyle]="{'background-image': 'url(' + rowData.thumbsrc + ')'}"></span>
                <span *ngIf="!rowData.thumbsrc" class="file-type-icon">
                    <sync-icon [name]="fileItemService.getFileTypeIcon(rowData)"></sync-icon>
                </span>
                <sync-list [ListItems]="infoListItems"></sync-list>
            </div>
            <!-- Include your Info tab content end -->

            <div *ngIf="activeTab === 'Sharing'" class="tab-content">
                <!-- Share container start -->
                <div class="shared-folder" *ngIf="(rowData.is_dir === 1)">
                    <sync-list [ListItems]="sharedFolderItems">
                    </sync-list>
                    <div class="avatar-group" *ngIf="team_shared_members.length > 0">
                        <sync-avatar-group [avatars]="team_shared_members" type="individual" [limit]="24">
                        </sync-avatar-group>
                    </div>
                </div>
                <!-- Share container end -->
                <!-- Link container start -->
                <div class="shared-file">
                    <sync-list [ListItems]="sharedFileItems">
                    </sync-list>
                    <ng-container *ngIf="rowData?.is_publink === 1">
                        <div class="link-container">
                            <sync-text-field inputType="text" [readOnly]="true" label="" [disabled]="true"
                                [value]="shareLinkUrl" inputSize="small">
                            </sync-text-field>
                            <sync-button class="copy-link-btn" label="Copy link" type="flat" [appCopyLink]="rowData"
                                [leadAdornment]="true" leadIconAdornment="copy-file"></sync-button>
                        </div>
                        <sync-list [ListItems]="linkInfo">
                        </sync-list>
                    </ng-container>
                </div>
            </div>

            <!-- History tab content start -->
            <div *ngIf="activeTab === 'History'" class="tab-content">
                <!-- Conditionally display History Items -->
                <ng-container *ngIf="historyItems.length > 0">
                    <div class="history-sub">
                        <sync-list [ListItems]="historyItems"></sync-list>
                    </div>
                    <div class="history-button-container" *ngIf="historyItems.length >= 5 && !isViewFullHistory">
                        <!-- Wrap the button in a container -->
                        <sync-button size="medium" label="View full history" type="flat"
                            [onClick]="onFullHistory"></sync-button>
                    </div>
                    <!-- Template for no more events available -->
                    <ng-container *ngIf="isViewFullHistory">
                        <p class="selectedRows body-1">No more version history available.</p>
                    </ng-container>
                </ng-container>

                <!-- Template for no events -->
                <ng-container *ngIf="historyItems.length === 0">
                    <p class="selectedRows body-1">No version history available.</p>
                </ng-container>
            </div>
            <!-- History tab content end -->
        </ng-container>
    </ng-container>
</div>